<template>
    <Modal v-if="visible" @cancel="$emit('cancel')">
        <ModalCardConfirm
            :activeValidate="true"
            :headerTitle="title"
            :maxWidth="maxWidth"
            @cancel="$emit('cancel')"
            @confirm="$emit('confirm')"
        >
            <span>
                {{ message }}
            </span>
        </ModalCardConfirm>
    </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCardConfirm from '@/components/ui-components/ModalCardConfirm.vue';

export default defineComponent({
    name: 'PreavisDeleteModal',
    components: { Modal, ModalCardConfirm },
    props: {
        visible: { type: Boolean, required: true },
        title: { type: String },
        message: { type: String, required: true },
        maxWidth: { type: String, default: () => '80%' },
    },
    emits: ['cancel', 'confirm'],
});
</script>

<style scoped></style>
